module.exports = __webpack_public_path__ + "static/media/logo-blue.4eadb3a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/branding/logo-blue.svg
// module id = 137
// module chunks = 2